import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

import {theme} from '@/config/theme';

export const LiveChallengeTemplate = () => (
  <Grid
    container
    size={12}
    p={1.5}
    display={'flex'}
    justifyContent={'space-between'}
    spacing={1}
    sx={{
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'background.default',
      position: 'relative',
      height: '103px',
    }}>
    <Grid size={5} display={'flex'} flexDirection={'column'}>
      <Skeleton variant="text" width="130px" height="21px" />
      <Grid
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'flex-start'}>
        <Grid display={'flex'} alignItems={'flex-end'} gap={1}>
          <Skeleton variant="text" width="30px" height="15px" />
          <Skeleton variant="text" width="30px" height="15px" />
        </Grid>
        <Skeleton variant="text" width="107px" height="55px" />
      </Grid>
    </Grid>
    <Grid width={'131px'} display={'flex'} flexDirection={'column'}>
      <Grid display={'flex'} alignItems={'start'} gap={1}>
        <Skeleton variant="circular" width="50px" height="35px" />
        <Grid display={'flex'} flexDirection={'column'} width={'90%'}>
          <Skeleton variant="text" width="50px" height="20px" />
          <Skeleton variant="text" width="83px" height="20px" />
        </Grid>
      </Grid>
      <Grid display={'flex'} alignItems={'start'} gap={1} mt={1}>
        <Skeleton variant="circular" width="50px" height="35px" />
        <Grid display={'flex'} flexDirection={'column'} width={'90%'}>
          <Skeleton variant="text" width="50px" height="20px" />
          <Skeleton variant="text" width="83px" height="20px" />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);
